import { AbstractSerializer } from '../../../common/AbstractSerializer';
import type { BinaryReader } from '../../../common/BinaryReader';
import Header from '../../../common/Header.js';
import type { LayerRecord } from '@visualizer/types';

export default class HeaderSerializer extends AbstractSerializer<Header> {
    public readonly version = 6;
    private resultNumber = 0;

    constructor(..._args: any[]) {
        super();
    }

    public async read(reader: BinaryReader, layer: LayerRecord = {}): Promise<Header> {
        const header = new Header();

        const readMajorVersion = reader.readUInt32();
        const readMinorVersion = reader.readUInt32();
        const readReleaseVersion = reader.readUInt32();
        header.version = `v${readMajorVersion}_${readMinorVersion}_${readReleaseVersion}`;
        console.log('Header v', header.version);
        header.numSensPnts = reader.readUInt32();
        layer.simKind = reader.readUInt32();
        this.resultNumber = reader.readUInt8();

        let resultLabelBackup = '';
        for (let s = 0; s < this.resultNumber; s++) {
            reader.readString(); // Result label. Not used in this version?
        }

        header.chunkID = reader.readUInt8();
        if (header.chunkID > 15) {
            throw new Error(`Error in reading chunk id.. Check if your strings contain accents. resultLabel: ${resultLabelBackup}`);
        }
        console.log('header chunkID', header.chunkID);
        reader.readUInt32();
        return header;
    }
}
